import { render, staticRenderFns } from "./listeAvenantByAPD.vue?vue&type=template&id=5920df6e&scoped=true&"
import script from "./listeAvenantByAPD.vue?vue&type=script&lang=js&"
export * from "./listeAvenantByAPD.vue?vue&type=script&lang=js&"
import style0 from "./listeAvenantByAPD.vue?vue&type=style&index=0&id=5920df6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5920df6e",
  null
  
)

export default component.exports